import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { SharedService } from '../../../services/shared.service';

@Component({
  standalone: false,
  selector: 'app-order-autocomplete',
  templateUrl: './order-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss']
})
export class OrderAutocompleteComponent {
  @Input() placeholder: string;
  items: Array<any> = [];
  input: string;
  isListVisible: boolean;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private sharedService: SharedService,
              private message: MessageService) {}

  getAllItems(): any {
    this.getOrders();
  }

  getOrders(): any {
    this.sharedService.getOrders(0, 50, this.input).subscribe(
      res => {
        this.items = res.results;
        this.isListVisible = this.items.length > 0 && this.input.length > 0;
      },
      err => {
        this.message.error(err);
      }
    )
  }

  onSelect(item: any): any {
    this.selected.emit(item);
    this.isListVisible = false;
    // this.input = '';
  }

  trackByFn(index: number): number {
    return index;
  }
}
